import axios from 'axios'

export const HTTP = axios.create({
    // baseURL: `https://apistella.tms.my.id/api/`
    baseURL: `https://apistella.stella-airfreshener.com/api/`
    // baseURL: `https://devstella.tmsid.site/api/` ini salah
    // baseURL: `http://localhost:8000/api/`
})

